<template>
    <v-dialog v-model="dialog" width="600">
        <template v-slot:activator="{ on, attrs }">
			<slot name="activator" v-bind="{ on, attrs }"/>
		</template>
        <v-card>
            <v-card-title v-if="user">
                Formulario: {{ user.username }}
            </v-card-title>
            <v-card-title v-else>
                Nuevo Usuario
            </v-card-title>
            <v-divider/>
            <v-card-text class="pa-3">
                <UserForm
                    :loading="loading"
                    v-model="userData"
                    :default="defaultUserData"
                    :valid.sync="isUserDataValid"
                    :context="context"
                    />
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <v-btn color="primary" text :disabled="loading" @click="reset()">RESETEAR</v-btn>
                <v-btn color="primary" :disabled="!isValid || loading" :loading="loading" @click="submit()">
                    <v-icon class="mr-1">mdi-content-save</v-icon>
                    <span>GUARDAR</span>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import UserService from '@/services/operadora/institution/UserService';

import UserForm from '@components/entities/general/user/form.vue';

export default {
    components: {
        UserForm,
    },
    props: {
        user: {},
    },
    data: function () {
        return {
            loading: false,
            dialog: false,

            context: 'new',
            userData: {},
            defaultUserData: null,
            isUserDataValid: false,
        }
    },
    computed: {
        isValid: function () {
            return this.isUserDataValid;
        }
    },
    methods: {
        reset: function () {
            this.loading = false;
            if (this.user) {
                this.context = 'edit';
                this.defaultUserData = { ... this.user };
            } else {
                this.context = 'new';
                this.defaultUserData = {};
            }
            this.userData = {};
        },
        submit: async function () {
            if (!this.isValid) return;
            this.loading = true;

            const data = { ... this.userData};

            try {
                if (this.user?.id) {
                    const {
                        user
                    } = await UserService.update(this.user.id, data);
    
                    this.emit(user)
                } else {
                    const {
                        user
                    } = await UserService.create(data);
    
                    this.emit(user)
                }
            } catch (error) {
                // TODO
            }

            this.loading = false;
        },
        emit: function (user) {
            this.$emit('saved', user);
            this.dialog = false;
        }
    },
    watch: {
        dialog: function () {
            this.reset();
        },
    }
}
</script>